import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { CssBaseline } from '@mui/material'

import Header from 'components/layouts/Header'
import Footer from 'components/layouts/Footer'
import Index from 'components/pages/Index'
import DJMax from 'components/pages/DJMax'
import DJMaxPs4 from 'components/pages/DJMaxPs4'
import CppTool from 'components/pages/CppTool'
import Factorio from 'components/pages/Factorio'
import { ProvideAuth } from 'hooks/useOAuth'

const AppRouter = () =>
  <ProvideAuth>
    <BrowserRouter>
      <div>
        <CssBaseline />
        <Header />
        <main>
          <Routes>
            <Route path='/' element={<Index />} />
            <Route path='/djmax' element={<DJMax />} />
            <Route path='/djmaxps4' element={<DJMaxPs4 />} />
            <Route path='/cpptool' element={<CppTool />} />
            <Route path='/factorio' element={<Factorio />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  </ProvideAuth>

export default AppRouter
